module.exports = __webpack_public_path__ + "img/b2c.91b128eb.svg";